jQuery(function($) {
    $(".nav li").click(function() {
        $(this).addClass('active').siblings().removeClass('active');
        $(document).on("click", function(event){
            var $trigger = $(".nav li");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $(".nav li").removeClass("active");
            }            
        });
    });
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".header, .nav_mobiles").addClass("header_background_active");
        } else {
            $(".header, .nav_mobiles").removeClass("header_background_active");
        }
    });
    $(".nav_mobiles .button_menu").click(function() {
        $nav =  $('.nav_mobiles .nav');
        $main = $('.wrapper_god');
        if($(this).hasClass('button_active')){
            $(this).removeClass('button_active');
            $($nav).removeClass('nav_active');
            $($main).removeClass('nav_active');
        } else {
            $(this).addClass('button_active')
            $($nav).addClass('nav_active');
            $($main).addClass('nav_active');
        }
    });
    $(window).scroll(function() {                  // assign scroll event listener
        var fixmeTop = $('.scroll_detect').offset().top;   // get initial position of the element
        var currentScroll = $(window).scrollTop(); // get current position
        var fixmeBottom = $('.footer').offset().top - 800;   // get initial position of the element
        if (currentScroll >= fixmeTop) {           // apply position: fixed if you
            $('.fixme').addClass('fixed');
        } else {                                   // apply position: static
            $('.fixme').removeClass('fixed');
        }
        if (currentScroll >= fixmeBottom) {           // apply position: fixed if you
            $('.fixme').addClass('absoluted');
        } else {
            $('.fixme').removeClass('absoluted');
        }
    });
    $(window).scroll(function() {
        var winScroll = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        var scrolled = (winScroll / height) * 100;
        document.getElementById("myBar2").style.width = scrolled + "%";
        document.getElementById("myBar").style.width = scrolled + "%";
    });
    $("article").ready(function() {
        var wordsPerMinute = 200; // Average case.
        var textLength = $(this).text().split(' '); // Split by words
        var value = (textLength.length / wordsPerMinute);
        var result = value.toFixed(0);
        document.getElementById("readingTime").innerText = "Reading time: " + result + " min";
    });
    $(window).load(function(){
        $('a[href*="#"]').on('click', function(e) {
            e.preventDefault()
            var extraOffset = 100;
            $('html, body').animate(
              { scrollTop: $($(this).attr('href')).offset().top - extraOffset,}, 800,'linear'
            )
          })
    });
});
/*
 * Table of Contents jQuery Plugin - jquery.toc
 *
 * Copyright 2013-2016 Nikhil Dabas
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.  You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied.  See the License for the specific language governing permissions and limitations
 * under the License.
 */

(function ($) {
    "use strict";
    // Builds a list with the table of contents in the current selector.
    // options:
    //   content: where to look for headings
    //   headings: string with a comma-separated list of selectors to be used as headings, ordered
    //   by their relative hierarchy level
    var toc = function (options) {
        return this.each(function () {
            var root = $(this),
                data = root.data(),
                thisOptions,
                stack = [root], // The upside-down stack keeps track of list elements
                listTag = this.tagName,
                currentLevel = 0,
                headingSelectors;
            // Defaults: plugin parameters override data attributes, which override our defaults
            thisOptions = $.extend(
                {content: "body", headings: "h1,h2,h3"},
                {content: data.toc || undefined, headings: data.tocHeadings || undefined},
                options
            );
            headingSelectors = thisOptions.headings.split(",");

            // Set up some automatic IDs if we do not already have them
            $(thisOptions.content).find(thisOptions.headings).attr("id", function (index, attr) {
                // In HTML5, the id attribute must be at least one character long and must not
                // contain any space characters.
                //
				// We just use the HTML5 spec now because all browsers work fine with it.
                // https://mathiasbynens.be/notes/html5-id-class
                var generateUniqueId = function (text) {
                    // Generate a valid ID. Spaces are replaced with underscores. We also check if
                    // the ID already exists in the document. If so, we append "_1", "_2", etc.
                    // until we find an unused ID.
                    if (text.length === 0) {
                        text = "?";
                    }
                    var baseId = text.toLowerCase().replace(/[^0-9a-zA-Z]+/g, "-").replace(/\-$/, ""), suffix = "", count = 1;

                    while (document.getElementById(baseId + suffix) !== null) {
                        suffix = "" + count++;
                    }

                    return baseId + suffix;
                };

                return attr || generateUniqueId($(this).text());
            }).each(function () {
                // What level is the current heading?
                var elem = $(this), level = $.map(headingSelectors, function (selector, index) {
                    return elem.is(selector) ? index : undefined;
                })[0];

                if (level > currentLevel) {
                    // If the heading is at a deeper level than where we are, start a new nested
                    // list, but only if we already have some list items in the parent. If we do
                    // not, that means that we're skipping levels, so we can just add new list items
                    // at the current level.
                    // In the upside-down stack, unshift = push, and stack[0] = the top.
                    var parentItem = stack[0].children("li:last")[0];
                    if (parentItem) {
                        stack.unshift($("<" + listTag + "/>").appendTo(parentItem));
                    }
                } else {
                    // Truncate the stack to the current level by chopping off the 'top' of the
                    // stack. We also need to preserve at least one element in the stack - that is
                    // the containing element.
                    stack.splice(0, Math.min(currentLevel - level, Math.max(stack.length - 1, 0)));
                }
                // Add the list item
                $("<li/>").appendTo(stack[0]).append(
                    $("<a/>").text(elem.text()).attr("href", "#" + elem.attr("id"))
                );

                currentLevel = level;
            });
        });
    }, old = $.fn.toc;
    $.fn.toc = toc;
    $.fn.toc.noConflict = function () {
        $.fn.toc = old;
        return this;
    };
    // Data API
    $(function () {
        toc.call($("[data-toc]"));
    });
    // Adds Active element to TOC
    $(function() {
        $(window).scroll(function() {
            $(":header").each(function() {
            var extraOffset = $(window).height()*0.3;
            if ($(window).scrollTop() >= $(this).offset().top - extraOffset) {
                var id = $(this).attr('id');
                $('.post-toc a').removeClass('active');
                $('.post-toc a[href="#' + id + '"]').addClass('active');
            }
            });
        });
    });
}(window.jQuery));
/*! tinyscrollbar - v2.5.0 - 2016-02-09
 * http://www.baijs.com/tinyscrollbar
 *
 * Copyright (c) 2016 Maarten Baijs <wieringen@gmail.com>;
 * Licensed under the MIT license */